import React, { Component } from "react"
import BookingTable from "./booking-history-data/table-generator/booking-table"
import { hosts } from "./booking-history-module"
import * as endpoints from "../../../booking/constants/Endpoints.js"
import axios from "axios"

export default class BookingHistory extends Component {
  constructor(props) {
    super(props)

    let bookings = [{}]
    let activeBookings = [{}]
    this.state = {
      bookings,
      activeBookings,
      loading: true,
      getStatus: this.getBookingStatus,
    }
  }

  componentDidMount() {
    this.getBookingList()
  }

  convertBookingTime = (datetime) => {
    let receivedDateTime = new Date(datetime).toISOString().substring(0, 10) + " " + new Date(datetime).toISOString().substring(11, 16)

    let yy = receivedDateTime.substring(0, 4)
    let mm = receivedDateTime.substring(5, 7)
    let dd = receivedDateTime.substring(8, 10)

    let receivedTime = receivedDateTime.substring(11, 16)
    let combinedDateTime = `${dd}/${mm}/${yy} ${receivedTime}`

    return combinedDateTime
  }

  getBookingStatus = (booking) => {
    switch (booking.status.trim()) {
      case "C":
        return this.props.statusConfirmed || "Bekræftet"
      case "CA":
        return this.props.statusAmmended || "Ændret"
      case "CO":
        return this.props.statusUpgraded || "Opgraderet"
      case "COE":
        return this.props.statusUpgradedByEmail || "Opgraderet"
      case "CX":
        return this.props.statusCancelled || "Annulleret"
      case "CXN":
        return this.props.statusCancelledNoShow || "Udeblevet"
      case "P":
        return this.props.statusPending || "Venter"
      case "R":
        return this.props.statusInReserved || "Reserveret"
      case "PR":
        return this.props.statusCapacityReleaseCancel || "CapacityReleaseCancel"
    }
  }

  //#region Data & Manipulation
  //the double whammy
  getBookingList = () => {
    const cookie = document.cookie
      .split(";")
      .map((cookie) => cookie.split("="))
      .reduce((accumulator, [key, value]) => ({ ...accumulator, [key.trim()]: decodeURI(value) }), {})

    let count = 0

    const headers = {
      headers: {
        Authorization: `Bearer ${cookie["CPH.SSO.Token"]}`,
      },
    }
    axios
      .get(`${endpoints.BOOKING_BY_USER_LIST(hosts)}?pagesize=500`, headers)
      .then((response) => {
        var pages = response.data.lastPage
        let bookings = response.data.bookings //[{}];

        bookings.forEach((booking) => {
          booking.id = count
          count += 1
        })
        // //#### For muptiple pages .. turn back to this later ..
        // for (let i = 1; i <= pages; i++) {
        //     axios.get(`${endpoints.BOOKING_BY_USER_LIST(hosts)}?page=${i}`, headers)
        //         .then(response => {
        //             bookings.push.apply(bookings, response.data.bookings);
        //             this.setState({
        //                 bookings: bookings
        //             })
        //         })
        //         .catch(error => {
        //             console.error('An error occured looping through booking data.', error);
        //         })
        // }
        // bookings.shift();
        this.setState({
          bookings: bookings,
          loading: false,
        })
      })
      .catch((error) => {
        console.error("an error occured", error)
      })
  }

  isBookingActive = (booking) => {
    if (Date.now() > new Date(booking.arrivalDateTime) && Date.now() < new Date(booking.departureDateTime) && booking.status !== "CX") {
      return true
    }
    return false
  }

  getActiveBookings = (bookings) => {
    return bookings.filter((b) => this.isBookingActive(b))
  }

  getPendingBookings = (bookings) => {
    return bookings.filter((b) => this.isBookingPending(b))
  }

  isBookingPassed = (booking) => {
    if (Date.now() > new Date(booking.departureDateTime) || booking.status === "CX") {
      return true
    }
    return false
  }

  isBookingPending = (booking) => {
    if (Date.now() < new Date(booking.arrivalDateTime) && booking.status !== "CX") {
      return true
    }
    return false
  }

  getPassedBookings = (bookings) => {
    return bookings.filter((b) => this.isBookingPassed(b))
  }
  //#endregion

  render() {
    let activeBookings = this.getActiveBookings(this.state.bookings)
    let comingBookings = this.getPendingBookings(this.state.bookings)
    let previousBookings = this.getPassedBookings(this.state.bookings).reverse()

    return (
      <React.Fragment>
        <BookingTable //active booking table
          sourceTable={"active-booking"}
          loadStatus={this.state.loading}
          pageHeader={this.props.pageTitle}
          header={this.props.activeBookingHeader}
          bookingStatus={this.props.bookingStatus}
          bookingDate={this.props.bookingDate}
          bookingReservationNumber={this.props.bookingReservationNumber}
          bookingArrivalDate={this.props.bookingArrivalDate}
          bookingDepartureDate={this.props.bookingDepartureDate}
          bookingCarpark={this.props.bookingCarpark}
          bookingPrice={this.props.bookingPrice}
          bookingLicenceplate={this.props.bookingLicenceplate}
          bookingLoadingText={this.props.bookingLoadingText}
          bookingNoBookingsText={this.props.bookingNoBookingsText}
          bookingNoSearchResultsText={this.props.bookingNoSearchResultsText}
          showMore={this.props.showMore}
          showLess={this.props.showLess}
          bookings={activeBookings}
          showDatePicker={false}
          getStatus={this.getBookingStatus}
          convertBookingTime={this.convertBookingTime}
          showAccordion={true}
          lang={this.props.lang}
        />

        <BookingTable //coming booking table
          sourceTable={"coming-booking"}
          loadStatus={this.state.loading}
          header={this.props.comingBookingHeader}
          bookingStatus={this.props.bookingStatus}
          bookingDate={this.props.bookingDate}
          bookingReservationNumber={this.props.bookingReservationNumber}
          bookingArrivalDate={this.props.bookingArrivalDate}
          bookingDepartureDate={this.props.bookingDepartureDate}
          bookingCarpark={this.props.bookingCarpark}
          bookingPrice={this.props.bookingPrice}
          bookingLicenceplate={this.props.bookingLicenceplate}
          bookingLoadingText={this.props.bookingLoadingText}
          bookingNoBookingsText={this.props.bookingNoBookingsText}
          bookingNoSearchResultsText={this.props.bookingNoSearchResultsText}
          bookingDatePickerFrom={this.props.bookingDatePickerFrom}
          bookingDatePickerTo={this.props.bookingDatePickerTo}
          showMore={this.props.showMore}
          showLess={this.props.showLess}
          bookings={comingBookings}
          showDatePicker={true}
          datepickerButtonText={this.props.datePickerButtonText}
          minDateToday={true}
          getStatus={this.getBookingStatus}
          convertBookingTime={this.convertBookingTime}
          showAccordion={true}
          lang={this.props.lang}
        />

        <BookingTable //previous booking table
          sourceTable={"previous-booking"}
          loadStatus={this.state.loading}
          header={this.props.previousBookingHeader}
          bookingStatus={this.props.bookingStatus}
          bookingDate={this.props.bookingDate}
          bookingReservationNumber={this.props.bookingReservationNumber}
          bookingArrivalDate={this.props.bookingArrivalDate}
          bookingDepartureDate={this.props.bookingDepartureDate}
          bookingCarpark={this.props.bookingCarpark}
          bookingPrice={this.props.bookingPrice}
          bookingLicenceplate={this.props.bookingLicenceplate}
          bookingLoadingText={this.props.bookingLoadingText}
          bookingNoBookingsText={this.props.bookingNoBookingsText}
          bookingNoSearchResultsText={this.props.bookingNoSearchResultsText}
          bookingDatePickerFrom={this.props.bookingDatePickerFrom}
          bookingDatePickerTo={this.props.bookingDatePickerTo}
          showMore={this.props.showMore}
          showLess={this.props.showLess}
          bookings={previousBookings}
          showDatePicker={true}
          datepickerButtonText={this.props.datePickerButtonText}
          minDateToday={false}
          getStatus={this.getBookingStatus}
          convertBookingTime={this.convertBookingTime}
          showAccordion={true}
          lang={this.props.lang}
        />
      </React.Fragment>
    )
  }
}

/*<BookingTable documentation
 * sourceTable               : css class added to table, table header, table elements. Used to identify which table is being rendered.
 * loadStatus                : Indicates to the users that data is being loaded when true, switches to table data when false.
 * header                    : header text for the table
 * bookingStatus             : text for column 1 in table
 * bookingDate               : text for column 2 in table
 * bookingReservationNumber  : text for column 3 in table
 * bookingArrivalDate        : text for column 4 in table
 * bookingDepartureDate      : text for column 5 in table
 * bookingCarpark            : text for column 6 in table
 * bookingPrice              : text for column 7 in table
 * bookingLicenceplate       : text for column 8 in table
 * bookings                  : Booking data coming from the getBookingList method.
 * showDatePicker            : Bool if true, renders date picker component.
 * datepickerButtonText      : Button text on the retrieve button for datepicker component.
 * minDateToday              : Bool if true, allows date picker to only pick dates going forward.
 * getStatus                 : Method to translate booking statuses in column 1 of row-data.
 * convertBookingTime        : Method to normalize booking time.
 * showAccordion             : allows the component to generate an accordion if there are many elements in the table.
 * lang                      : gets the locale />
 */
